<template>
  <a-table :dataSource="billList"
           :columns="billColumns"
           :pagination="pagination"
           row-key="id"
           :loading="tableLoading"
           bordered
           @change="onPaginationChange">

    <template #roomTitle="{ text }">
      <span class="line-clamp-2">{{ text }}</span>
    </template>

    <template #actualStartTime="{ text }">
      {{ text ? $f.datetime(text, 'YYYY-MM-DD HH:mm') : ' - ' }}
    </template>

    <template #actualEndTime="{ record }">
      {{ getDuration(record) }}
    </template>

    <template #costHour="{ text }">
      {{ text ? text : ' - ' }}
    </template>
  </a-table>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from "vue";
import _ from "lodash";
import { useRoute, useRouter } from "vue-router";

import liveApi from "@/service/api/live";
import { timestampToHour } from "@/global";

export default defineComponent({
  name: "LiveBillList",
  props: [],
  emits: [],
  components: {},
  setup() {
    // 充值明细
    const route = new useRoute();
    const router = new useRouter();

    const billColumns = [
      {
        title: "直播主题",
        dataIndex: "roomTitle",
        slots: { customRender: "roomTitle" },
        width: 250,
      },
      {
        title: "开始时间",
        dataIndex: "actualStartTime",
        slots: { customRender: "actualStartTime" },
      },
      {
        title: "直播时长",
        dataIndex: "actualEndTime",
        slots: { customRender: "actualEndTime" },
      },
      {
        title: "观看人数",
        dataIndex: "viewerTotalNum",
      },
      {
        title: "耗费时长(小时）",
        dataIndex: "costHour",
        slots: { customRender: "costHour" },
      },
      {
        title: "剩余时长(小时）",
        dataIndex: "remainHour",
      },
    ];

    const getDuration = (record) => {
      if (!record.actualStartTime) {
        return " - ";
      }
      const duration = record.actualEndTime - record.actualStartTime;
      const timer = timestampToHour(duration);

      if (timer.hours) {
        return `${timer.hours}时${timer.minutes}分${timer.seconds}秒`;
      }
      if (timer.minutes) {
        return `${timer.minutes}分${timer.seconds}秒`;
      }
      return `${timer.seconds}秒`;
    };

    const tableLoading = ref(false);
    const rows = ref([]);
    const searchForm = reactive({});
    const pagination = reactive({
      current: 1,
      pageSize: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "50"],
      showSizeChanger: true,
      showTotal: (total) => `共 ${total} 条`,
      showQuickJumper: true,
    });
    const pullQueryParams = (query) => {
      for (let key in searchForm) {
        searchForm[key] = query[key] ? query[key] : "";
      }

      if (query.page) {
        pagination.current = _.toInteger(query.page);
      }

      if (query.size) {
        pagination.pageSize = _.toInteger(query.size);
      }
    };
    const fetchPaginationData = async () => {
      tableLoading.value = true;
      const response = await liveApi.billList({
        page: pagination.current - 1,
        size: pagination.pageSize,
      });
      rows.value = response.data;
      pagination.total = response.total;
      tableLoading.value = false;
    };
    const onPaginationChange = async (pagination, filters, sorter) => {
      let sortParams = {};
      if (sorter.field && sorter.order) {
        sortParams = {
          sort:
            sorter.field + "," + (sorter.order === "ascend" ? "asc" : "desc"),
        };
      } else {
        sortParams = { sort: "" };
      }
      const query = _.assign(
        {},
        route.query,
        { page: pagination.current, size: pagination.pageSize },
        sortParams
      );
      pullQueryParams(query);
      fetchPaginationData();
      router.push({ name: route.name, query: query });
    };

    onMounted(async () => {
      pullQueryParams(route.query);
      await fetchPaginationData();
    });

    return {
      billColumns,
      billList: rows,
      pagination,
      pullQueryParams,
      fetchPaginationData,
      onPaginationChange,
      tableLoading,

      getDuration,
    };
  },

  beforeRouteUpdate(to, from, next) {
    next();
    this.pullQueryParams(to.query);
    this.fetchPaginationData();
  },
});
</script>
<style lang='less' scoped>
</style>